import request from '@/utils/request';

export const getServiceList = (params: any) =>
  request({
    url: 'Servicer/servicerList',
    method: 'get',
    params
  });

export const addService = (data: any) =>
  request({
    url: 'Servicer/servicer',
    method: 'POST',
    data
  });

export const getService = (params: any) =>
  request({
    url: 'Servicer/servicer',
    method: 'get',
    params
  });

export const agree = (data: any) =>
  request({
    url: 'Servicer/agree',
    method: 'POST',
    data
  });

export const deleteService = (data: any) =>
  request({
    url: 'Servicer/servicer',
    method: 'DELETE',
    data
  });

export const servicerAddList = (params: any) =>
  request({
    url: 'Servicer/servicerAddList',
    method: 'get',
    params
  });
